import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import util from "./utils/util";
import "amfe-flexible";

const app = createApp(App);

router.beforeEach((to, from, next) => {
  const merchantID = sessionStorage.getItem("merchant_id");
  if (to.meta.keepAlive) {
    if (merchantID === "undefined" || merchantID == null || merchantID === "") {
      next({ path: "/login" });
    } else {
      next();
      if (to.meta.title) {
        document.title = to.meta.title;
      }
    }
  } else {
    next();
    if (to.meta.title) {
      document.title = to.meta.title;
    }
  }
  // window.document.title = '微店'
  // next()
});
// console.log(util);

app.config.globalProperties.$util = util;

app.use(store).use(router).mount("#app");
